var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#trash-outline_svg__clip0_358_3240)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1a1 1 0 011-1h8a1 1 0 011 1v3h6a1 1 0 110 2H1a1 1 0 010-2h6V1zm8 1v2H9V2h6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.997 8.929a1 1 0 00-1.994.142l.867 12.142A3 3 0 006.862 24h10.276a3 3 0 002.992-2.787l.867-12.142a1 1 0 00-1.994-.142l-.867 12.142a1 1 0 01-.998.929H6.862a1 1 0 01-.998-.93L4.997 8.93z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "trash-outline_svg__clip0_358_3240"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgTrashOutline;